import { ISigSyncEventType } from './ISigSyncEventType';

export type ISigSyncProgressionLine =
  | 'CANCELED'
  | 'COMPLETE'
  | 'NOT_SIGNED'
  | 'PREPARING_DOCS'
  | 'REQUESTING'
  | 'SIGNING';

export enum eSigSyncProgressionLine {
  Complete = 'COMPLETE',
  Canceled = 'CANCELED',
  NotSigned = 'NOT_SIGNED',
  PreparingDocs = 'PREPARING_DOCS',
  Requesting = 'REQUESTING',
  Signing = 'SIGNING',
}

const labelsByProgressionLine = {
  CANCELED: 'Canceled',
  COMPLETE: 'Complete',
  NOT_SIGNED: 'Did Not Sign',
  PREPARING_DOCS: 'Preparing Docs',
  REQUESTING: 'Requesting',
  SIGNING: 'Signing',
};

export const getSigSyncProgressionLineLabel = (eventType: ISigSyncProgressionLine): string => {
  return labelsByProgressionLine[eventType];
};

const sequenceOrderByLine = {
  CANCELED: 5,
  COMPLETE: 4,
  NOT_SIGNED: 5,
  PREPARING_DOCS: 2,
  REQUESTING: 1,
  SIGNING: 3,
};

export const sortSigSyncProgressionLines = (lines: ISigSyncProgressionLine[]): ISigSyncProgressionLine[] => {
  return lines.sort((a, b) => sequenceOrderByLine[a] - sequenceOrderByLine[b]);
};

export const getLatestActiveLineIndex = (
  sortedLines: ISigSyncProgressionLine[],
  progressions: Record<ISigSyncProgressionLine, ISigSyncEventType | null>
): number => {
  let latestIndex = 0;
  for (let i = 0; i < sortedLines.length; i++) {
    if (progressions[sortedLines[i]]) {
      latestIndex = i;
    }
  }
  return latestIndex;
};
